import { jwtDecode } from 'jwt-decode';

import { TokenDecodeError } from './errors';
import type { UserInfo } from './user-info';

export const getUserFromToken = (token: string) => {
  try {
    return jwtDecode<UserInfo>(token, {});
  } catch {
    throw new TokenDecodeError();
  }
};
